// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__3AwAW","validationTips":"StatementDescriptor_validationTips__1le_5"};